import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

export const getTimeAgo = () => {
    TimeAgo.addLocale(en);
    const timeAgo = new TimeAgo('en-US');

    return timeAgo;
};
